import React from "react";
import Create from "modules/payments/components/Create";

const PaymentCreatePage = () => {
  return (
    <div>
      <Create />
    </div>
  );
};

export default PaymentCreatePage;
